import { Dispatch, FC, SetStateAction } from 'react';
import { Common } from '~js/React/Enums';

type Props = {
  displayMediaView: Dispatch<SetStateAction<boolean>>;
  setMediaOption: Dispatch<SetStateAction<string>>;
};

const MediaViewHeader: FC<Props> = ({ displayMediaView, setMediaOption }) => {
  function backMediaView() {
    displayMediaView(false);
    setMediaOption('imageView');

    var url = window.location.href.split('#')[0];
    const newUrl = url;
    window.history.replaceState(null, null, newUrl);
  }
  return (
    <div className="top-0 left-0 z-[1004] fixed bg-white w-screen h-12 lg:h-16">
      <div className="relative flex items-center m-auto px-4 w-full max-w-7xl h-full">
        <button
          className="group flex lg:flex-row flex-col items-center gap-0 lg:gap-3 mb-1- lg:mb-0"
          onClick={() => {
            backMediaView();
          }}
        >
          <img
            className="w-[1.3rem] lg:w-6 h-auto rotate-180 transition-all group-hover:lg:-translate-x-1 transform"
            src="/Images/Icons/Arrows/arrow-right-blue700.svg"
            alt="Ikon pil"
          />
          <span className="font-icb text-blue700 text-tiny xl:text-base leading-6">
            {Common.Back}
          </span>
        </button>
        <img
          className="top-1/2 left-1/2 absolute w-auto h-7 -translate-x-1/2 -translate-y-1/2"
          loading="lazy"
          src="/Images/logotypes/logo.svg"
          alt="Länsförsärkringar Fastighetsförmedling logotyp"
          width={164}
          height={28}
        />
      </div>
    </div>
  );
};

export default MediaViewHeader;
